import React from "react";
import { Button } from "antd";

const EmptyStateCard = ({ icon, header, subHeader, btnText, btnIcon, onBtnClick }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-1 py-8">
      {icon && <div>{icon}</div>}
      {header && <p className="text-black-88 mt-3 text-sm font-semibold mb-0">{header}</p>}
      {subHeader && <p className="text-black-45 text-sm font-normal mb-0">{subHeader}</p>}
      {btnText && (
        <Button type="link" className="!mt-5" icon={btnIcon} onClick={onBtnClick}>
          {btnText}
        </Button>
      )}
    </div>
  );
};

export default EmptyStateCard;
